import { render, staticRenderFns } from "./PageSetting.vue?vue&type=template&id=1c0d6c44"
import script from "./PageSetting.vue?vue&type=script&lang=js"
export * from "./PageSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports